import { render } from "./DetailProgram.vue?vue&type=template&id=7d8dc993"
import script from "./DetailProgram.vue?vue&type=script&lang=js"
export * from "./DetailProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__